import React, { useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";
import * as DiIcons from "react-icons/di";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../pages/Landing/Home.css";
import "../../data/data.json";

const Skills = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <div className="section_5 pt-5 semi-md:pt-[80px]">
        <h1
          data-aos="fade-up"
          className="text-center font-bold text-[30px] underline"
        >
          Skills
        </h1>
        <div className="py-10 grid gap-1 px-1 grid-cols-4 grid-rows-1 sm:grid-cols-2 md:grid-rows-2">
          <div
            className="lg:dark:bg-[#092c44] lg:bg-zinc-100 rounded-md"
            data-aos="fade-up"
          >
            <div className="p-5 mt-5 bg-[#0093df] hover:bg-[#0093dfbf] w-fit aspect-square rounded-[50%] mx-auto">
              <BsIcons.BsFront className="text-[20px] text-white " />
            </div>
            <div className="flex flex-col items-center">
              <h1 className="text-center text-[20px] font-bold">Frontend</h1>
              <div>
                <ul className="">
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    HTML
                  </li>
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    Css
                  </li>
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    JavaScript
                  </li>
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    ReactJs
                  </li>
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    NextJs
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="lg:dark:bg-[#092c44] lg:bg-zinc-100 rounded-md"
            data-aos="fade-up"
          >
            <div className="p-5 mt-5 bg-[#0093df] hover:bg-[#0093dfbf] w-fit aspect-square rounded-[50%] mx-auto">
              <BsIcons.BsBack className="text-[20px] text-white " />
            </div>
            <div className="flex flex-col items-center">
              <h1 className="text-center text-[20px] font-bold">Backend</h1>
              <div>
                <ul className="">
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    NodeJs/ExpressJs
                  </li>
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    NestJs
                  </li>
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    Apollo/GraphQl
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="lg:dark:bg-[#092c44] lg:bg-zinc-100 rounded-md"
            data-aos="fade-up"
          >
            <div className="p-5 mt-5 bg-[#0093df] hover:bg-[#0093dfbf] w-fit aspect-square rounded-[50%] mx-auto">
              <FaIcons.FaDatabase className="text-[20px] text-white " />
            </div>
            <div className="flex flex-col items-center">
              <h1 className="text-center text-[20px] font-bold">Database</h1>
              <div>
                <ul className="">
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    MongoDB
                  </li>
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    SQL
                  </li>
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    {" "}
                    neo4j
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="lg:dark:bg-[#092c44] lg:bg-zinc-100 rounded-md"
            data-aos="fade-up"
          >
            <div className="p-5 mt-5 bg-[#0093df] hover:bg-[#0093dfbf] w-fit aspect-square rounded-[50%] mx-auto">
              <DiIcons.DiAndroid className="text-[20px] text-white " />
            </div>
            <div className="flex flex-col items-center">
              <h1 className="text-center text-[20px] font-bold">Native</h1>
              <div>
                <ul className="">
                  <li className="text-zinc-600 dark:text-zinc-400 flex items-center gap-1">
                    Flutter
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="pl-[8%]">
          {" "}
          <h1 data-aos="fade-up" className=" text-[20px]">
            + Skills
          </h1>
          <div data-aos="fade-up">
            <ul>
              <li className="text-zinc-600 dark:text-zinc-400">TypeScript</li>
              <li className="text-zinc-600 dark:text-zinc-400">Redux</li>
              <li className="text-zinc-600 dark:text-zinc-400">Tailwind css</li>
              <li className="text-zinc-600 dark:text-zinc-400">Mui</li>
              <li className="text-zinc-600 dark:text-zinc-400">Git</li>
              <li className="text-zinc-600 dark:text-zinc-400">Docker</li>
              <li className="text-zinc-600 dark:text-zinc-400">Figma</li>
            </ul>
          </div>
        </div>{" "}
      </div>
    </>
  );
};

export default Skills;
